import { defineComponent as a } from "vue";
import { n } from "./_plugin-vue2_normalizer-Bj5bLKV4.mjs";
const i = a({
  name: "NcSavingIndicatorIcon",
  props: {
    /**
     * Specify the size of the saving icon.
     */
    size: {
      type: Number,
      default: 20
    },
    /**
     * Specify what is saved.
     */
    name: {
      type: String,
      default: ""
    },
    /**
     * Set to true when saving is in progress.
     */
    saving: {
      type: Boolean,
      default: !1,
      required: !1
    },
    /**
     * Set to true if an error occured while saving.
     */
    error: {
      type: Boolean,
      default: !1,
      required: !1
    }
  },
  emits: ["click"],
  computed: {
    indicatorColor() {
      return this.error ? "var(--color-error)" : this.saving ? "var(--color-primary-element)" : "none";
    }
  }
});
var o = function() {
  var e = this, r = e._self._c;
  return e._self._setupProxy, r("span", { staticClass: "material-design-icon", attrs: { "aria-label": e.name, role: "img" }, on: { click: function(t) {
    return e.$emit("click", t);
  } } }, [r("svg", { staticClass: "material-design-icon__svg", attrs: { fill: e.fillColor, width: e.size, height: e.size, viewBox: "0 0 24 24" } }, [r("path", { attrs: { fill: e.indicatorColor, d: "m19 15a4 4 0 0 0-4 4 4 4 0 0 0 4 4 4 4 0 0 0 4-4 4 4 0 0 0-4-4z" } }), r("path", { attrs: { fill: "currentColor", d: "M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" } }, [e.name ? r("title", [e._v(e._s(e.name))]) : e._e()])])]);
}, l = [], s = /* @__PURE__ */ n(
  i,
  o,
  l,
  !1,
  null,
  null,
  null,
  null
);
const _ = s.exports;
export {
  _ as N
};
